import AgencyBillingPage from "./AgencyBillingPage";

export default function AgencyBillingRoute() {
  return <AgencyBillingPage />;
}
